import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AddressesContainer extends ThemeComponent {
    @Ref() addAddressButton!: HTMLButtonElement;
    @Ref() addAddressForm!: HTMLDivElement;
    @Ref() cancelAddAddressButton!: HTMLElement;

    init() {

        // Show add address form
        this.$listen(this.addAddressButton, 'click', () => {
            this.addAddressForm.classList.toggle('visually-hidden');
        });

        // Cancel add address form
        this.$listen(this.cancelAddAddressButton, 'click', () => {
            this.addAddressForm.classList.add('visually-hidden');
        });
    }
}
